'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { contentVariants, thVariants } from "./Th.variants.js";
import { cleanTableProps } from "../cleanTableProps.js";
import { useTableContext } from "../Table/index.js";
import { useTableHeadContext } from "../THead/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { cn } from "../../../utils/index.js";
const iconNameMap = {
    ascending: 'north',
    descending: 'south',
    unsorted: 'unfold_more'
};
function Th({ children, className, onClick, ...props }) {
    const { headerCellInteractive: tableHeaderCellInteractive, firstColumnSticky, bordered: tableBordered } = useTableContext();
    const { interactive: tableHeadInteractive } = useTableHeadContext();
    const { interactive: headCellInteractive } = props;
    const interactive = headCellInteractive ?? tableHeadInteractive ?? tableHeaderCellInteractive;
    const classes = cn(thVariants({
        ...props,
        interactive,
        firstColumnSticky,
        tableBordered
    }), className);
    const contentClasses = contentVariants(props);
    const { description, sort = 'disabled' } = props;
    const iconName = iconNameMap[sort] || 'unfold_more';
    const cleanedProps = cleanTableProps(props);
    return /*#__PURE__*/ jsx("th", {
        className: classes,
        onClick: onClick,
        ...cleanedProps,
        children: /*#__PURE__*/ jsxs("div", {
            className: contentClasses,
            children: [
                children,
                description && /*#__PURE__*/ jsx(Tooltip, {
                    side: "top",
                    triggerNode: /*#__PURE__*/ jsx(CdnIcon, {
                        iconName: "info"
                    }),
                    children: description
                }),
                'disabled' !== sort && /*#__PURE__*/ jsx(CdnIcon, {
                    iconName: iconName
                })
            ]
        })
    });
}
export { Th };
